export const CONTACT_ADDRESS_MAX_LENGTH = 255;
